module.exports = __webpack_public_path__ + "static/media/ic_grid.ccab81f0.svg";